export const DeleteDialogController = ($scope, $mdDialog, callback, target, item) => {
    "ngInject";

    $scope.callback = callback;
    $scope.target = target;
    $scope.item = item;
    
    $scope.closeDialog = () => {
        $mdDialog.hide();
    };

    $scope.delete = () => {
        callback();
        $mdDialog.hide();
    };
};


// WEBPACK FOOTER //
// ./sources/components/common/delete-dialog/delete-dialog.js